/**
 * Declared once because Home, SRP, and VDP each fetch only their own domain's experiment
 * list — a single declaration in one domain would register the flag without bucketing the
 * other two pages.
 */
export const EMBEDDED_APPRAISAL_FLOW_EXPERIMENT =
  'car-merch-ui-embedded-appraisal-flow';
